<template>
    <section class="w-full py-16 bg-white px-6 lg:px-24 font-poppins antialiased">
  <div class="max-w-full mx-auto relative">
    <!-- Section Header -->
    <div class="text-center ">
      <div class="flex items-center justify-center mb-4">
        <div class="h-7 w-1 bg-[#186a85] opacity-80 rounded-lg"></div>
        <span class="px-3 py-1 text-[#186a85] text-lg tracking-wider font-normal bg-opacity-20">Our Products</span>
      </div>
      <h2 class="text-4xl font-normal text-gray-800 ">Technology of the <span class="relative inline-block">Future
        <svg class="absolute -bottom-2 left-0 w-full" viewBox="0 0 200 8" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,5 Q40,0 80,5 T160,5 T240,5" stroke="#186a85" stroke-width="3" fill="none" stroke-linecap="round" />
        </svg>
      </span></h2>
      <p class="text-lg text-gray-500 max-w-3xl mx-auto mt-4">We are proud to introduce to you our best software solutions.</p>
    </div>

    <!-- Product Cards -->
<div class="max-w-full mx-auto grid grid-cols-1 gap-12 py-8">

  <!-- OTP -->
  <div class="flex flex-col xl:flex-row justify-center items-center gap-12">
    <div class="w-full xl:w-1/2 flex justify-center">
      <img src="@/assets/OTP.svg" alt="Ontime Payroll" class="max-w-full">
    </div>
    <div class="w-full xl:w-1/2 p-8 shadow-md rounded-3xl text-center xl:text-left">
      <h3 class="text-2xl font-medium text-gray-600">Ontime Payroll (OTP)</h3>
      <div class="border-2 border-[#186a85] opacity-85 w-full mx-auto xl:mx-0 my-4"></div>
      <p class="text-gray-500 text-md mb-6 text-justify">OnTime Payroll is a Software as a Service (SaaS) application that has many tools to help manage your Employee Attendance and Payroll. Starting from Employee management, work schedules, Permissions, Sickness & Leave, Attendance Process, Payroll Process and many other features.</p>
      <a href="https://www.programgaji.com/" target="_blank" class="text-black font-medium flex justify-center xl:justify-start items-center gap-2">
        <img src="https://www.svgrepo.com/show/520912/right-arrow.svg" alt="" class="w-8 h-8">
        <span>Learn More</span>
      </a>
    </div>
  </div>

 <!-- BIS -->
<div class="flex flex-col-reverse xl:flex-row justify-center items-center gap-12">
  <!-- Text Content -->
  <div class="w-full xl:w-1/2 p-8 shadow-md rounded-3xl text-center xl:text-left xl:items-start">
    <h3 class="text-2xl font-medium text-gray-600">BIS Accounting</h3>
    <div class="border-2 border-[#186a85] opacity-85 w-full mx-auto xl:mx-0 my-5 "></div>
    <p class="text-gray-500 text-md mb-6 text-justify">
      BIS Accounting is a Software as a Service (SaaS) application that has many tools to help manage your business. Starting from inventory, transactions, reports, customers, suppliers and many other features.
    </p>
    <a href="https://www.bisaccounting.com/" target="_blank" class="text-black font-medium flex justify-center xl:justify-start items-center gap-2">
      <img src="https://www.svgrepo.com/show/520912/right-arrow.svg" alt="" class="w-8 h-8">
      <span>Learn More</span>
    </a>
  </div>

  <!-- Image -->
  <div class="w-full xl:w-1/2 flex justify-center xl:justify-end">
    <img src="@/assets/BIS.svg" alt="BIS" class="max-w-sm md:max-w-md lg:max-w-lg">
  </div>
</div>

   <!-- Phipos -->
  <div class="flex flex-col xl:flex-row justify-center items-center gap-12">
    <div class="w-full xl:w-1/2 flex justify-center">
      <img src="@/assets/phipos.svg" alt="Phipos" class="max-w-full">
    </div>
    <div class="w-full xl:w-1/2 p-8 shadow-md rounded-3xl text-center xl:text-left">
      <h3 class="text-2xl font-medium text-gray-600">Phipos</h3>
      <div class="border-2 border-[#186a85] opacity-85 w-full mx-auto xl:mx-0 my-4"></div>
      <p class="text-gray-500 text-md mb-6 text-justify">PhiPOS is a point-of-sale system that aim to help all merchant in growing their businesses. All feature of PhiPOS are run on a real time basis using cloud which means you can monitor all data from the dashboard from the comfort of your home.</p>
      <a href="https://pos.phisoft.co.id/" target="_blank" class="text-black font-medium flex justify-center xl:justify-start items-center gap-2">
        <img src="https://www.svgrepo.com/show/520912/right-arrow.svg" alt="" class="w-8 h-8">
        <span>Learn More</span>
      </a>
    </div>
  </div>

<!-- CLOUDHOMES -->
<div class="flex flex-col-reverse xl:flex-row justify-center items-center gap-12">
  <!-- Text Content -->
  <div class="w-full xl:w-1/2 p-8 shadow-md rounded-3xl text-center xl:text-left xl:items-start">
    <h3 class="text-2xl font-medium text-gray-600">Cloudhomes</h3>
    <div class="border-2 border-[#186a85] opacity-85 w-full mx-auto xl:mx-0 my-4"></div>
    <p class="text-gray-500 text-md mb-6 text-justify">
      Cloudhomes is a smart property management platform that streamlines rental processes for property owners and tenants. Features include an integrated booking system, smart door lock control, automated billing, and real-time monitoring.
    </p>
    <a href="https://www.programgaji.com/" target="_blank" class="text-black font-medium flex justify-center xl:justify-start items-center gap-2">
      <img src="https://www.svgrepo.com/show/520912/right-arrow.svg" alt="" class="w-8 h-8">
      <span>Learn More</span>
    </a>
  </div>

  <!-- Image -->
  <div class="w-full xl:w-1/2 flex justify-center xl:justify-end">
    <img src="@/assets/cloudhomes.svg" alt="Cloudhomes" class="max-w-sm md:max-w-md lg:max-w-lg xl:max-w-full">
  </div>
</div>

    </div>
  </div>
</section>

</template>